/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const createTitleFromTemplate = (title: string, template: string): string =>
	template.replace(/%s/, title);

export const ripTitleTemplateFromMeta = (getMeta: (arg1: string) => string | null): string | null =>
	getMeta('ajs-app-title');

export const checkDocumentTitle = (
	symbol: symbol,
	contextArray: (TitleContextObject | symbol)[],
): boolean => {
	const lastDocumentTitle = contextArray[contextArray.length - 1];
	if (typeof lastDocumentTitle === 'object' && lastDocumentTitle.symbol === symbol) {
		return true;
	}

	return false;
};

export type TitleContextObject = {
	title: string;
	symbol: symbol;
};

export type State = {
	title: string;
	defaultTitle: string;
	contextArray: (TitleContextObject | symbol)[];
};

export type DocumentTitleContainerProps = {
	titleSuffix: string | null;
};
